'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * BrokerLeadCardNotice
 *
 * Used to display an overdue, paused or pending state on the right inside the header.
 */
var BrokerLeadCardNotice = react.forwardRef(function (props, ref) {
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    __css: styles.notice,
    ref: ref
  }, props, {
    className: utils.cx('chakra-broker-lead-card__notice', props.className)
  }));
});
BrokerLeadCardNotice.displayName = 'BrokerLeadCardNotice';
exports.BrokerLeadCardNotice = BrokerLeadCardNotice;